import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=5dcdf7b2&scoped=true&"
var script = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=5dcdf7b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcdf7b2",
  null
  
)

export default component.exports